import projection from '../generated/pwj218f1.json';
import type { AcceptanceManifest } from '../types';

export const pwj218f1AcceptanceManifest = projection as AcceptanceManifest;
